// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"246":"cc83d190","488":"db74de84"}[chunkId] + ".chunk.js";
};